<template>
  <div class="container">
    <form action="post" @submit.prevent="createNote" :class="{ 'was-validated': submitted}">

      <div class="form-group">
        <label for="note">Notering</label>
        <textarea class="form-control" id="note" rows="10" required v-model="note.Notes"></textarea>
      </div>

      <button type="button" class="btn btn-link" @click="$router.go(-1)">Avbryt</button>
      <button type="submit" class="btn btn-primary" @click="submitted = true">Spara</button>
    </form>
  </div>
</template>
<script>
import appService from '../appService'

export default {
  props: ['id'],

  data () {
    return {
      submitted: false,
      note: {
        CustomerId: this.id,
        Notes: ''
      }
    }
  },

  methods: {
    createNote () {
      appService.createNote(this.note)
      .then(() => { this.$router.go(-1) })
      .catch(() => { this.error = 'Det gick inte att spara.' })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/NoteAdd.vue